import { DateTime } from 'luxon';

import { toServerDate } from '@/globals';

export interface ILineItemCreativeAPI {
  lineitemcreative_id: number;
  creative_id: number;
  lineitem_id: number;
  weight: number;
  local_from_date: string;
  local_to_date: string;
}

export default class LineItemCreative {
  id: number;

  creativeID: number;

  lineItemID: number;

  weight: number;

  fromDate?: DateTime;

  toDate?: DateTime;

  constructor(id = -1, creativeID: number, lineItemID: number, weight: number, fromDate?: DateTime, toDate?: DateTime) {
    this.id = id;
    this.creativeID = creativeID;
    this.lineItemID = lineItemID;
    this.weight = weight;
    this.fromDate = fromDate;
    this.toDate = toDate;
  }

  static fromApi(apiObject: ILineItemCreativeAPI): LineItemCreative {
    return new LineItemCreative(
      apiObject.lineitemcreative_id,
      apiObject.creative_id,
      apiObject.lineitem_id,
      apiObject.weight,
      apiObject.local_from_date != null ? DateTime.fromISO(apiObject.local_from_date) : null,
      apiObject.local_to_date != null ? DateTime.fromISO(apiObject.local_to_date).minus({ days: 1 }) : null,
    );
  }

  toApi(): ILineItemCreativeAPI {
    return {
      lineitemcreative_id: this.id >= 0 ? this.id : undefined,
      creative_id: this.creativeID,
      lineitem_id: this.lineItemID,
      weight: this.weight,
      local_from_date: this.fromDate != null ? toServerDate(this.fromDate) : null,
      local_to_date: this.toDate != null ? toServerDate(this.toDate.plus({ days: 1 })) : null,
    };
  }
}
